export type NbsChartDataTableProps = {
  readonly headers: readonly string[];
  readonly rows: readonly (readonly (string | number)[])[];
  readonly caption?: string;
};

export function NbsChartDataTable({ headers, rows, caption }: NbsChartDataTableProps) {
  if (rows.length === 0) return null;
  return (
    <div className="nbs-chart-data-table">
      <table>
        {caption ? <caption>{caption}</caption> : null}
        <thead>
          <tr>
            {headers.map((h) => (
              <th key={h} scope="col">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
